import { isString as _isString } from 'lodash';

import { Status } from '../../validation';

export default (status?: Status): boolean => {
    return _isString(status);
};
